import React, { Fragment, Component } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
import { FlagsProvider } from 'flag';

import { CanonicalRoute, Footer, Header, RedirectWithStatus } from 'components';

import {
  BulkResize,
  PdfResize,
  PdfCompressor,
  Log,
  CompressImages,
  Contact,
  Help,
  ViewImage,
  ImageResize,
  NotFound,
  Privacy,
  TermsOfService,
  Delete
} from '..';

import CropImages from 'containers/Features/CropImages';
import PhotoEditor from 'containers/Features/PhotoEditor';
import PhotoCompress from 'containers/Features/PhotoCompress';

import withScrollToTop from 'hoc/withScrollToTop';
import { FEATURE_FLAGS } from 'constants/features';
import intl from 'react-intl-universal';
import { getLocales } from 'utils';
// locale data
const locales = getLocales();
// import global styles file
import './styles';
// function userRedirect(nextState, replace) {
//   var defaultLanguage = 'en';
//   var redirectPath = defaultLanguage + nextState.location.pathname
//   replace({
//     pathname: redirectPath,
//   })
// };

// const langs = '/:lng(' + Object.keys(locales).join('|') + ')?';
const langs = '';
function renderBody({ render404 }) {

  if (render404) {
    return <NotFound />;
  }

  return (
    <Switch>
      <CanonicalRoute exact path='/image/:imageId' component={ ViewImage } />
      <CanonicalRoute exact path='/del/:imageId' component={ Delete } />
      <CanonicalRoute exact path={'/log'} component={ Log } />
      <CanonicalRoute exact path={langs + '/'} component={ ImageResize } />
      <CanonicalRoute exact path={langs + `/bulk-resize`} component={ BulkResize } />
      <CanonicalRoute exact path={langs + '/compress-images'} component={ CompressImages } />
      <CanonicalRoute exact path={langs + '/pdf-resize'} component={ PdfResize } />
      <CanonicalRoute exact path={langs + '/pdf-compressor'} component={ PdfCompressor } />
      <CanonicalRoute exact path={langs + '/features/crop-photo'} component={ CropImages } />
      <CanonicalRoute exact path={langs + '/features/photo-editor'} component={ PhotoEditor } />
      <CanonicalRoute exact path={langs + '/features/compress-images'} component={ PhotoCompress } />
      <CanonicalRoute exact path={langs + '/contact'} component={ Contact } />
      <CanonicalRoute exact path={langs + '/help'} component={ Help } />
      <CanonicalRoute exact path={langs + '/privacy'} component={ Privacy } />
      <CanonicalRoute exact path={langs + '/terms-of-service'} component={ TermsOfService } />
      {/* <CanonicalRoute exact path={langs + '/view/:imageId'} component={ ViewImage } /> */}
      <CanonicalRoute exact path={langs + '/edit/:imageId'} component={ ImageResize } />
      {/* <RedirectWithStatus from='/features' to='/en/features/crop-photo' status={ 301 } /> */}
      <RedirectWithStatus from='/features' to='/features/crop-photo' status={ 301 } />
      {/* <RedirectWithStatus from='/' to='/en' status={ 301 } /> */}
      <RedirectWithStatus from='/view/:id' to='/' status={ 301 } />
      <RedirectWithStatus from='/Thumbnail/:id' to='/' status={ 301 } />
      <RedirectWithStatus from='/Output/:id' to='/' status={ 301 } />
      {/* <Route path="*" onEnter={userRedirect} /> */}
      <Route component={ NotFound } />
    </Switch>
  );
}

class App extends Component {

  constructor(props) {
    super(props);
    let currentLocale = 'en'; 
    
    let pathname = props.location.pathname;
    const pathparts = pathname.split("/");
    if(pathname === '/') {
      pathname = '/' + currentLocale;
    } else if(pathparts && pathparts[1] && locales[pathparts[1]]) {
      currentLocale = pathparts[1];
    } else {
      pathname = '/' + currentLocale + pathname;
    }

    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: require(`../../locales/${currentLocale}.json`)
      }
    });
    
    this.state = {
      currentLocale,
      pathname
    }
  }

  render() {
    return (
      <FlagsProvider flags={ FEATURE_FLAGS }>
        <Fragment>
          <Helmet>
            <title>Crop and Resize Images Online | ImageResize.org</title>

            <script type="text/javascript">{`
              window._urq = window._urq || [];
              _urq.push(['initSite', '0149e32c-c4f3-4b7a-bb30-bef8979d0977']);
              (function() {
                var ur = document.createElement('script'); ur.type = 'text/javascript'; ur.async = true;
                ur.src = ('https:' == document.location.protocol ? 'https://cdn.userreport.com/userreport.js' : 'http://cdn.userreport.com/userreport.js');
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ur, s);
              })();
            `}</script>
            <script async src="https://www.googletagmanager.com/gtag/js?id=UA-92539064-1"></script>
            <script>{`
              if(typeof gtag != "function") {
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                
                gtag('config', 'UA-92539064-1');
                
              }
            `}</script>
          </Helmet>
          <Header />
          { renderBody(this.props) }
          <Footer />
          <script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5bf04be949787064"></script>
        </Fragment>
      </FlagsProvider>
    );
  }
}

export default withScrollToTop(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx